export const AUTH_TOKEN_EXPIRATION_TIME = 3 * 60 * 60
